import AboutUsModule from 'components/about-us/AboutUsModule';
import AboutUsSiteContainer from 'components/about-us/AboutUsSiteContainer';
import ImageWithFallback from 'components/ImageWithFallback';
import Link from 'next/link';
import { HOMEPAGE_BUCKET_LINK } from 'utils/image/bucketLinks';
import { EnterButton } from '../enter-button/EnterButton';
import styles from './Homepage-Footer.module.css';
import { useEnterStore } from 'hooks/stores/useEnterStore';
import { PLAYER_FIRST_NAME_FALLBACK } from 'components/referrals/2026/ReferralConstants';

interface Props {
  isSubscriber: boolean;
  referrerFirstName?: string;
}

export const HomePageFooter = ({ isSubscriber, referrerFirstName }: Props) => {
  const enterStore = useEnterStore();
  return (
    <AboutUsModule background={'tealGradient'}>
      <AboutUsSiteContainer>
        <div className={styles.footerSection}>
          <div className={styles.footerContent}>
            <h2 className={`aboutUsTypographyHeaderXlargeOnTeal noMargin`}>
              {referrerFirstName != undefined && enterStore.isReferralFlow ? (
                `Join ${referrerFirstName || PLAYER_FIRST_NAME_FALLBACK} and win prizes every week`
              ) : (
                <>
                  Win Prizes, <br />
                  Plant Trees
                </>
              )}
            </h2>
            <p className="noMargin">
              Dream holidays, home renovations <br /> & so much more
            </p>
            {!isSubscriber && (
              <div className={styles.enterButtonContainer}>
                <EnterButton />
              </div>
            )}
          </div>

          <div className={styles.footerLogos}>
            <Link href="/giving-back">
              <a>
                <ImageWithFallback
                  src={{
                    src: `${HOMEPAGE_BUCKET_LINK}/veritree-logo.svg`,
                    width: 100,
                    height: 64,
                  }}
                  alt="Giving Back"
                  className={styles.asSeenOnImage}
                />
              </a>
            </Link>
            <Link href="https://uk.trustpilot.com/review/daymade.co.uk">
              <a target="_blank" rel="noopener noreferrer">
                <ImageWithFallback
                  src={{
                    src: `${HOMEPAGE_BUCKET_LINK}/trustpilot-black.webp`,
                    width: 80,
                    height: 62,
                  }}
                  alt="Trustpilot"
                  className={styles.trustpilotImage}
                />
              </a>
            </Link>
          </div>
        </div>
      </AboutUsSiteContainer>
    </AboutUsModule>
  );
};
